import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Successes } from 'src/infrastructure/labels/successes';
import { Card } from 'src/models/DTO/card/Card';
import { Cards } from 'src/models/DTO/card/Cards';
import { OrderInfo } from 'src/models/DTO/orders/orderInfo';
import { PaymentMethods } from 'src/models/DTO/payMethods/paymentMethods';
import { PlainPaymentMethod } from 'src/models/DTO/payMethods/plainPaymentMethod';
import { UserDTO } from 'src/models/DTO/user/user';
import { ToastService } from 'src/services/core/toast/toast.service';
import { PayMethodsService } from 'src/services/request/pay-methods/pay-methods.service';
import { StripeService } from 'src/services/request/stripe/stripe.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';
import { OrederStateService } from 'src/services/state/order/oreder-state.service';

@Component({
  selector: 'app-selectcard',
  templateUrl: './selectcard.component.html',
  styleUrls: ['./selectcard.component.css']
})
export class SelectcardComponent extends HistoryBaseComponent implements OnInit {


  selectedPayment?: Card;

  private _cards: Cards = { data: [] }
  private _order?: OrderInfo;
  private _loggedUser?: UserDTO;

  constructor(
    private stripeService: StripeService,
    private orderStateService: OrederStateService,
    private router: Router,
    private loggedUserService: LoggedUserService,
    private toastr: ToastService,
    protected location: Location,
    protected historyService: HistoryService
  ) {
    super(location, historyService);
    this.orderStateService.orderInfo$.subscribe(orederInfo => {
      this._order = orederInfo;
    })
  }

  private loadCards() {
    this.stripeService.getPaymentMethods(this._loggedUser!.data.payment_accounts[0].provider_account_id).subscribe((result) => {
      this._cards = result;
      if (this._order?.paymentCard) {
        this.selectedPayment = this._order?.paymentCard;
      }
      else {
        this.selectedPayment = this._cards.data[this._cards.data.length - 1];
      }
    })
  }

  ngOnInit(): void {
    this.loggedUserService.userInfo$.subscribe((user) => {
      if (Object.keys(user).length) {
        this._loggedUser = user;
        this.loadCards();
      }
    });
  }

  get cards() {
    return this._cards;
  }

  choose() {
    this._order!.paymentCard = this.selectedPayment!;
    this.orderStateService.addNewOrderInfo(this._order!);
    this.router.navigate(['order/details']);
  }

  createCard() {
    this.router.navigate(['payments/card']);
  }

  back() {
    this.router.navigate(['order/details']);
  }


  public getCardDetail(card: Card) {
    let cardName = "MASTERCARD *";
    if (card.card.brand == "visa") {
      cardName = "VISA DEBIT *";
    }
    return cardName + card.card.last4
  }

  public cardImg(card: Card) {
    let cardImage = '/assets/images/cards/card-mastercard.svg';
    if (card.card.brand == "visa") {
      cardImage = '/assets/images/cards/card-visa.svg';
    }
    return cardImage
  }

  public removeCard(card: Card) {
    this.cards.data = this.cards.data.filter(cardTmp => cardTmp.id != card.id);
    if (this.cards.data.length) {
      this.selectedPayment = this._cards.data[this._cards.data.length - 1];
    }
    this.stripeService.detachPaymentMethod(card.id).subscribe(() => {
      this._order!.paymentCard = undefined;
      this.orderStateService.addNewOrderInfo(this._order!);
      this.loadCards();
      this.toastr.success(Successes.bg.removeCard);
    })
  }
  
}
